import { observer }                              from 'mobx-react';
import { getAdvertiserAndAdvertiserShowMixData } from 'utils/advertiserProviderTool';
import AdvertiserModel                           from 'models/AdvertiserModel';
import { ApiCollection }                         from 'collections/ApiCollection';
import AdvertiserShowModel                       from 'models/AdvertiserShowModel';

interface SiderAdvertiserProps {
  advertiserCollection: ApiCollection<AdvertiserModel>;
  advertiserShow: AdvertiserShowModel;
}

const SiderAdvertiser = ({
  advertiserCollection,
  advertiserShow,
}: SiderAdvertiserProps) => {
  const advertiserFound = advertiserCollection.find(
      (advertiser: AdvertiserModel) => advertiser.get('@id') === advertiserShow.get('advertiser'),
  );

  if (!advertiserFound) {
    return null;
  }

  const { linkFull, wording } = getAdvertiserAndAdvertiserShowMixData(
    advertiserFound,
    advertiserShow,
  );

  return (
    <a
      className="AppSiderMenuBottom__advertiserShowLink"
      href={linkFull}
      key={advertiserShow.get('@id')}
      onClick={() => {
        advertiserShow.patch({ clicked: true });
      }}
      target="_blank"
    >
      <div className="AppSiderMenuBottom__advertiserShow">
        <div
          className="AppSiderMenuBottom__advertiserShowLogo"
          style={
            !advertiserFound
              ? {}
              : {
                backgroundImage: `url(${advertiserFound.get('logo.objectUrl')})`,
              }
          }
        />
        <div className="AppSiderMenuBottom__advertiserShowLink">{wording}</div>
      </div>
    </a>
  );
};

export default observer(SiderAdvertiser);
